import React from 'react';
import { CredentialCardProps } from '../../types/VerificationTypes';
import { Shield, User, Building2 } from 'lucide-react';

const CredentialCard: React.FC<CredentialCardProps> = ({ credential }) => {
  return (
    <div className="relative bg-gradient-to-br from-verified-green to-green-600 rounded-lg shadow-lg p-4 md:p-8 mb-6 text-white overflow-hidden">
      {/* VERIFIED Watermark */}
      <div className="absolute inset-0 flex items-center justify-center opacity-10">
        <span className="text-4xl md:text-8xl font-bold transform -rotate-45">VERIFIED</span>
      </div>
      
            <div className="relative z-10">
        {/* Credential Preview Display */}
        <div className="flex justify-center">
          <div className="border-2 border-gray-300 rounded-lg overflow-hidden bg-white shadow-lg">
            <div
              className="relative mx-auto"
              style={{
                width: '480px',
                height: '360px',
                backgroundColor: '#ffffff',
              }}
            >
              {/* Decorative border */}
              <div className="absolute inset-2 border-2 border-midnight-indigo rounded"></div>
              
              {/* Watermark */}
              <div 
                className="absolute inset-0 flex items-center justify-center pointer-events-none"
                style={{ transform: 'rotate(-45deg)' }}
              >
                <span className="text-6xl font-bold text-gray-200 opacity-30">VERIFIED</span>
              </div>

              {/* Header */}
              <div className="absolute top-8 left-0 right-0 text-center">
                <h2 className="text-lg font-bold text-midnight-indigo mb-2">
                  {credential.schema_name}
                </h2>
                <p className="text-sm text-warm-slate">
                  {credential.issuer_name}
                </p>
              </div>

              {/* Credential Details */}
              <div className="absolute top-24 left-8 right-8">
                <div className="space-y-4">
                  <div className="text-center">
                    <p className="text-sm text-warm-slate mb-1">Holder</p>
                    <p className="text-lg font-bold text-midnight-indigo">{credential.holder_name}</p>
                  </div>
                  
                  <div className="text-center">
                    <p className="text-sm text-warm-slate mb-1">Issuer</p>
                    <p className="text-base font-semibold text-midnight-indigo">{credential.issuer_name}</p>
                  </div>
                  
                  <div className="text-center">
                    <p className="text-sm text-warm-slate mb-1">Status</p>
                    <p className="text-base font-medium text-midnight-indigo">{credential.status}</p>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="absolute bottom-4 left-4 right-4 text-center text-xs text-warm-slate">
                <p>Credential ID: {credential.id}</p>
                <p>Issued: {new Date(credential.issued_at).toLocaleDateString()}</p>
                <p className="mt-1 text-xs">
                  Verify at: verify.credentialcapital.com/credential/{credential.id}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CredentialCard; 